import React from 'react'
import { AgroservicesForm, Faq } from '@/components/composed'
import { LandingBenefits, LandingHeader, LandingListInformation } from '@/components/composed/landingBlocks'
import { LandingAccessControlProvider } from '@/components/composed/landingBlocks/LandingAccessControlProvider'
import { agroservicesBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import { FieldEvaluationReportDialogPublicLauncher } from '@/pages/Financing/components/FieldEvaluationReportDialogPublicLauncher'
import { EAgroservicesProductId } from '@/types/EAgroservicesProductId'
import { asyncScrollIntoView } from '@/utils/helpers'
import { useWebpExtension } from '@/utils/hooks/image'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { getStaticImagePath } from '@/utils/images'
import { BENEFITS, EScrollEventBlockId, FAQ, LEARN_LIST, SOLUTION_LIST } from './constants'
import { messages } from './messages'
import './styles.scss'

export const EfisZsn: React.FC = () => {
  const { isDesktop, isMobile } = useDeviceType()
  const imageExtension = useWebpExtension()

  const backgroundImage = getStaticImagePath(`agroservices/agroservicesEfisZsn.${imageExtension}`)

  const leavingRequestClicked = () => () => {
    asyncScrollIntoView(`#${EScrollEventBlockId.agroserviceOfferForm}`)
  }

  return (
    <LandingAccessControlProvider>
      <div className="efisZsnPage">
        <LandingHeader
          isDeviceMobile={isMobile}
          titleText={messages.header.title}
          actionButtonText={messages.header.actionButton}
          descriptionText={messages.header.description}
          onActionClick={leavingRequestClicked()}
          styles={{
            backgroundImage: isDesktop ? `url("${backgroundImage}")` : undefined,
          }}
          breadcrumbCaptionId="breadcrumbs.agroservices.efisZsn"
          rootBreadcrumbs={[agroservicesBreadcrumb]}
          mobileImageUrl={`agroservices/agroservicesEfisZsn.${imageExtension}`}
          partnerImages={['efis-zsn']}
        />
        <LandingListInformation title={messages.learn.title} lists={LEARN_LIST} imageSrc={`agroservices/efisZsnLearn.${imageExtension}`} />

        <Faq className="page-wrapper" sectionId="faq" items={FAQ} title={messages.faq.title} />

        <LandingListInformation
          title={messages.solution.title}
          lists={SOLUTION_LIST}
          imageSrc={`agroservices/efisZsnSolution.${imageExtension}`}
        />

        <LandingBenefits className="efisZsnPageBenefits" titleTextId={messages.benefits.title} withoutBanner benefits={BENEFITS} />

        <AgroservicesForm
          blockId={EScrollEventBlockId.agroserviceOfferForm}
          productId={EAgroservicesProductId.EFIS_ZSN}
          id="efisZsnForm"
          messageFieldMaxLength={256}
          buttonSubmitText={messages.form.title}
        >
          <h2>{messages.form.title}</h2>
          <h3>{messages.form.description}</h3>
        </AgroservicesForm>
        <FieldEvaluationReportDialogPublicLauncher comment={messages.fieldEvaluationReportDialog.comment} />
      </div>
    </LandingAccessControlProvider>
  )
}
